"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TimerStore = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _msToTime = require("../../../../common/msToTime");

var _TimerTimer = require("./TimerTimer");

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

var TimerStore = (_class = (_temp =
/*#__PURE__*/
function () {
  function TimerStore() {
    var _this = this;

    (0, _initializerDefineProperty2.default)(this, "isRunning", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "timer", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "secondsToRun", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "hasSound", _descriptor4, this);
    this.updateTimeToRun(this.secondsToRun);
    this.timer.initStartTime();

    this.timer.onComplete = function () {
      _this.isRunning = false;
    };
  }

  var _proto = TimerStore.prototype;

  _proto.updateTimeToRun = function updateTimeToRun(secondsToRun) {
    this.timer.setSecondsToRun(secondsToRun);
  };

  _proto.startTimer = function startTimer() {
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;
    this.timer.start();
  };

  _proto.pauseTimer = function pauseTimer() {
    this.timer.pause();
    this.isRunning = false;
  };

  _proto.resetTimer = function resetTimer() {
    this.timer.reset();
  };

  _proto.toggleSound = function toggleSound() {
    this.hasSound = !this.hasSound;
  };

  (0, _createClass2.default)(TimerStore, [{
    key: "mainDisplay",
    get: function get() {
      return (0, _msToTime.msToTimerFormat)(this.timer.currentMilliseconds);
    }
  }, {
    key: "timeToRun",
    get: function get() {
      return (0, _msToTime.msToTimerFormat)(this.timer.msToRun);
    }
  }]);
  return TimerStore;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isRunning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "timer", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new _TimerTimer.TimerTimer();
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "secondsToRun", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 300;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasSound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateTimeToRun", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTimeToRun"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "mainDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mainDisplay"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "timeToRun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeToRun"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "startTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "startTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "pauseTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleSound", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSound"), _class.prototype)), _class);
exports.TimerStore = TimerStore;